export default [
  {
    path: '/categorias',
    name: 'categorias',
    component: () => import(/* webpackChunkName: "categorias" */ '@/pages/categorias/CategoriasPage.vue'),
    meta: { requiresAuth: true }
  }
]
